import { Avatar } from 'antd';
import React from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import ic_request_staff from './ic_request.svg';
import Icon from 'assets/Icons';
import anybodyImg from 'assets/icon-anybody.png';
const IconRequestStaff = () => <img src={ic_request_staff} alt="request-staff" style={{ width: '48px', height: '48px' }} />;

const StaffInfo = ({ value: staff, isItem, isRequestStaff }: { value?: IStaffItemData | null, isItem?: boolean, isRequestStaff?: boolean }) => {
  return (
    <Container className={isItem ? 'isItem' : ''}>
      <Avatar style={{ backgroundColor: staff?.anyBody ? '#fff' : '#f56a00', fontSize: '32px', color: '#fff' }} size={64} src={staff?.anyBody ? anybodyImg : (staff?.urlImage || 'fail')} >{staff?.firstName?.[0] || 'A'}</Avatar>
      <span>{staff?.firstName || 'Anyone'}</span>
      {isItem && <div style={{ zoom: 1.5 }}>
        <Icon type="changeCustomer" fill='#6FABB6' />
      </div>}
      {isRequestStaff && <IconRequestStaff />}
    </Container>
  );
};

export default StaffInfo;
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  span {
    color: #FFF;
    background: #232F3E;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  &.isItem span {
    overflow: hidden;
    color: #1D2129;
    background: transparent;
    text-align: center;
    text-overflow: ellipsis;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
`;
